import React from "react";
import FeatureGraphicPage from "./FeatureGraphicPage";

/**
 * 1080p ending capture — feature graphic fits fully in 1920×1080 (contain, no crop).
 * Open from PrototypeMain → 1080P - ENDING.
 */
export default function FeatureGraphicEndingPage() {
    return <FeatureGraphicPage endingCapture />;
}
